import { Component, OnInit, EventEmitter, Output, ElementRef, Renderer2 } from '@angular/core';
import { AuthenticationService } from '../_services';
import { User } from '../_models';
import { ThemeService } from '../_helpers/theming-engine/theme.service';
import { BreadcrumbService } from '../_helpers/breadcrumb/breadcrumb.service';

@Component({
    selector: 'header',
    templateUrl: 'header.component.html',
    styleUrls: [
        'header.component.css',
        'additional-styles/_header-bar.css',
        'additional-styles/_logo.css',
        'additional-styles/_breadcrumb.css',
        'additional-styles/_quicklinks.css',
        'additional-styles/_user-summary.css'
    ],
    standalone: false
})


export class HeaderComponent implements OnInit {
  public currentUser: User;
  public userConsoleToggled: boolean = false;

  constructor(
    private authService: AuthenticationService,
    public themeService: ThemeService,
    public breadcrumbService: BreadcrumbService,
    private renderer: Renderer2
    ) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
  }

  public toggleUserConsole(userConsole: ElementRef): void {
    this.userConsoleToggled = !this.userConsoleToggled;

    if (this.userConsoleToggled) {
      this.renderer.removeClass(userConsole, "hidden");
    } else {
      this.renderer.addClass(userConsole, "hidden");
    }
  }
}
